const ContractMethod = {
  ARTIST__BUY_EDITION: "ARTIST__BUY_EDITION",
  ARTIST__WITHDRAW_FUNDS: "ARTIST__WITHDRAW_FUNDS",
  SPLIT_MAIN__CREATE_SPLIT: "SPLIT_MAIN__CREATE_SPLIT",
  DRAFT_SPLIT_MAIN__CREATE_SPLIT: "DRAFT_SPLIT_MAIN__CREATE_SPLIT",
  DRAFT_SOUND_CREATOR__CREATE_SOUND_AND_MINTS: "DRAFT_SOUND_CREATOR__CREATE_SOUND_AND_MINTS",
  SPLIT_MAIN__DISTRIBUTE_ETH: "SPLIT_MAIN__DISTRIBUTE_ETH",
  SPLIT_MAIN__WITHDRAW: "SPLIT_MAIN__WITHDRAW",
  SOUND_CREATOR__CREATE_SOUND_AND_MINTS: "SOUND_CREATOR__CREATE_SOUND_AND_MINTS",
  SOUND_EDITION__WITHDRAW_ETH: "SOUND_EDITION__WITHDRAW_ETH",
  MULTICALL__WITHDRAW: "MULTICALL__WITHDRAW",
  AFFILIATE__WITHDRAW: "AFFILIATE__WITHDRAW",
  SAM__BUY_EDITION: "SAM__BUY_EDITION",
  SAM__SELL_EDITION: "SAM__SELL_EDITION"
};
const ContractMethodValues = Object.values(ContractMethod);
const LegacyContractMethod = {
  "Artist.buyEdition": ContractMethod.ARTIST__BUY_EDITION,
  "Artist.withdrawFunds": ContractMethod.ARTIST__WITHDRAW_FUNDS,
  "SplitMain.createSplit": ContractMethod.SPLIT_MAIN__CREATE_SPLIT,
  "SplitMain.distributeETH": ContractMethod.SPLIT_MAIN__DISTRIBUTE_ETH,
  "SplitMain.withdraw": ContractMethod.SPLIT_MAIN__WITHDRAW
};
const LegacyContractMethodValues = Object.keys(
  LegacyContractMethod
);
function parseContractMethod(value) {
  const contractMethod = ContractMethodValues.find((method) => value === method);
  if (contractMethod)
    return contractMethod;
  const legacy = LegacyContractMethodValues.find((method) => value === method);
  if (legacy)
    return LegacyContractMethod[legacy];
  throw Error("Invalid Contract Method: " + value);
}

export { ContractMethod, parseContractMethod };
